import { oc } from 'ts-optchain';
import { sortBy } from 'es-toolkit/compat';

import { core , safeEnumCompare } from '@tock/coretypes';
import { displayInDollars } from '@tock/money';
import protos from 'utils/protos';

const { TaxStrategy } = protos;

/**
 * A purchaseOrder has a field named `taxStrategy` that tells us whether the tax
 * strategy used was SINGLE_TAX or TAX_LIBRARY (multiple taxes).
 */
export function isTaxLibrary(taxStrategy: core.TaxStrategy | undefined | null): boolean {
  // This purchase was persisted in the DB using TAX_LIBRARY
  return safeEnumCompare(taxStrategy, TaxStrategy, TaxStrategy.TAX_LIBRARY);
}

/**
 * A purchaseOrder has a field named `taxStrategy` that tells us whether the tax
 * strategy used was TAX_CENTER.
 */
export function isTaxCenter(taxStrategy: core.TaxStrategy | undefined | null): boolean {
  // This purchase was persisted in the DB using TAX_LIBRARY
  return safeEnumCompare(taxStrategy, TaxStrategy, TaxStrategy.TAX_CENTER);
}

/**
 * Get taxes paid for reports. Either one or multiple tax line items
 */
export function getTax(
  tax: number,
  purchasedTaxLineItem: core.ITax[],
  taxStrategy: core.TaxStrategy
): string {
  if (safeEnumCompare(taxStrategy, TaxStrategy, TaxStrategy.TAX_CENTER)) {
    return displayInDollars(tax);
  } else if (safeEnumCompare(taxStrategy, TaxStrategy, TaxStrategy.SINGLE_TAX)) {
    return displayInDollars(tax);
  } else {
    return sortBy(purchasedTaxLineItem, (taxLineItem) => taxLineItem.name)
      .map(
        (taxLineItem) => `${taxLineItem.name} - ${displayInDollars(oc(taxLineItem).amountCents(0))}`
      )
      .join(', ');
  }
}
